import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    windheight: '',
    HomeNum:'',
    Qy_token: localStorage.getItem('Qy_token') ? localStorage.getItem('Qy_token') : '',
    Qy_userId: localStorage.getItem('Qy_userId') ? localStorage.getItem('Qy_userId') : '',
    Qy_userName: localStorage.getItem('Qy_userName') ? localStorage.getItem('Qy_userName') : '',
    Qy_userPhone: localStorage.getItem('Qy_userPhone') ? localStorage.getItem('Qy_userPhone') : '',
    Qy_userPost: localStorage.getItem('Qy_userPost') ? localStorage.getItem('Qy_userPost') : '',
    Qy_authRoter: localStorage.getItem('Qy_authRoter') ? localStorage.getItem('Qy_authRoter') : '',
  },
  mutations: {
    changeuser(state, user) {
      console.log(user);
      state.Qy_token = user.user.useref;
      state.Qy_userId = user.user.auId;
      state.Qy_userName = user.user.auName;
      state.Qy_userPhone = user.user.auAccount;
      state.Qy_userPost = user.user.auPost;
       state.Qy_authRoter = JSON.stringify( user.user.ajefRoleAuthList)
      localStorage.setItem('Qy_token', user.user.useref);
      localStorage.setItem('Qy_userId', user.user.auId);
      localStorage.setItem('Qy_userName', user.user.auName);
      localStorage.setItem('Qy_userPhone', user.user.auAccount);
      localStorage.setItem('Qy_userPost', user.user.auPost);
      localStorage.setItem('Qy_authRoter', JSON.stringify( user.user.ajefRoleAuthList));

    },
    getWindowHeight(state, data) {
      state.windheight = data.windheight;
    },
    getHomeNum(state, data) {
      console.log(data);
      state.HomeNum = data.HomeNum;
    }
  },
  actions: {
  },
  modules: {
  }
})
